import React, { useContext, useEffect, useState } from "react";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// Env
import Swiper from "../../modules/env/swiper-bundle.min.js";

// UI
import { closeLayerFn, initLayout, openAlertPopup, openLayerFn } from "../Layout";
import { getToday, request271 } from "./ResrvList";

// Temp Images

import { PostApi221, PostApi222, PostApi225 } from "../../modules/network/padoPost";

export const VisitReceipt = (props) => {
  const { userinfo, cfg, phonecfg, auth } = useContext(AppContext);

  const { doctorList, hpNm, hpKey, resrvType, callSTime, callETime } = props;

  const [appDrName, setAppDrName] = useState("");
  const [license, setLicense] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [appHour, setAppHour] = useState("0000");
  const [appCls, setAppCls] = useState("0");
  const [phKey, setPhKey] = useState("");
  const [pharmName, setPharmName] = useState("");

  const [saveFlag, setSaveFlag] = useState("N");

  useEffect(() => {
    $(".pp").click(function () {
      openLayerFn($(".visit-receipt-layer"));
    });

    $(".visit-receipt-layer .btn-circlexbtn").click(function () {
      $(".select-custom-box").find("a.btn-select").html("의료진 선택");
      closeLayerFn($(".visit-receipt-layer"));
    });

    $(".location").click(function () {
      openLayerFn($(".map-view-layer"));
    });

    $(".map-view-layer .btn-closex").click(function () {
      closeLayerFn($(".map-view-layer"));
    });

    $(".map-view-layer .btn-backpage").click(function () {
      closeLayerFn($(".map-view-layer"));
    });
  }, []);

  useEffect(() => {
    console.log("saveFlag : ", saveFlag);
    if (saveFlag == "Y") {
      let params = {
        hpKey: hpKey,
        license: license,
        appDrName: appDrName,
        appHour: appHour,
        appCls: appCls,
      };
      console.log("params:: ", params);
      request221(params);
    }
  }, [saveFlag]);

  // 접수처리
  const request221 = (params) => {
    PostApi221(userinfo, cfg, phonecfg, params)
      .then((res) => {
        if (res.resultCode == "-1") {
          openAlertPopup(
            "이미 접수하신 내역이 있습니다.\n예약현황에서 취소 후 신규 접수가 가능합니다."
          );

          setSaveFlag("N");
          // setAppDrName('');
          // setLicense('');
          // setAppHour('');
          // setAppCls('');
          $(".select-custom-box").find("a.btn-select").html("의료진 선택");
        } else if (res.resultCode == "-2") {
          openAlertPopup("접수가 불가능한 시간입니다. \n다른 시간을 선택해 주세요");
          setSaveFlag("N");
        } else if (res.resultCode == "000") {
          closeLayerFn($(".visit-receipt-layer"));
          _O.Open("/resrvList");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSelected = (e) => {
    let drNm = $(e.target).html();

    if (drNm.indexOf("(마감)") > -1 || drNm.indexOf("(휴진)") > -1) {
      openAlertPopup("마감 또는 휴진인 의료진은 선택 할 수 없습니다.");
      //$(".select-custom-box").find("a.btn-select").html("의료진 선택");
      return;
    }

    $(e.target).closest(".select-custom-box").removeClass("on");
    $(e.target).closest(".select-custom-box").find("a.btn-select").html($(e.target).html());
    setAppDrName($(e.target).html());
    setLicense(e.target.attributes.license.value);
    setStartTime(e.target.attributes.starttime.value);
    setEndTime(e.target.attributes.endtime.value);
  };

  const resrvReceipt = (receiptType) => {
    let compHour = "";
    let today = getToday("FULL").substring(8, 12);

    setAppCls(resrvType);

    if (resrvType == "1") {
      setLicense("미지정");
      setAppDrName("미지정");
    }

    if (hpKey == "") {
      openAlertPopup("병원 정보가 없습니다.");
      return;
    }

    if (receiptType == "I") {
      //즉시
      setAppHour("0000");

      if (resrvType == "0") {
        setLicense("미지정");
        setAppDrName("미지정");
      }
    } else if (receiptType == "R") {
      //접수
      let ampm = $(".reserv-pick-ampm .swiper-slide-active span").html();
      let hour = $(".reserv-pick-hour .swiper-slide-active span").html();
      let minute = $(".reserv-pick-minute .swiper-slide-active span").html();

      if (resrvType == "0") {
        if (license == "") {
          // openAlertPopup("의료진을 선택하세요.");
          // return;
          setLicense("미지정");
          setAppDrName("미지정");
        }

        // if(appDrName == "") {
        //     openAlertPopup("의료진을 선택하세요.");
        //     return;
        // }
      }

      if (appHour == "") {
        openAlertPopup("예약시간을 선택하세요.");
        return;
      }

      if (ampm == "오전") {
        if (hour.length === 1) {
          compHour = "0" + hour + minute;
        } else {
          compHour = hour + minute;
        }
      } else {
        compHour = parseInt(12) + parseInt(hour) + "" + minute;
      }

      if (today > compHour) {
        openAlertPopup("예약 시간이 현재 시간 보다 커야합니다.");
        return;
      }

      if (resrvType == "0") {
        if (startTime && startTime != "" && compHour < startTime) {
          openAlertPopup("선택된 의료진의 진료 시간이 아닙니다.");
          return;
        }

        if (endTime && endTime != "" && compHour > endTime) {
          openAlertPopup("선택된 의료진의 진료 시간이 아닙니다..");
          return;
        }
      } else {
        if (compHour < callSTime) {
          openAlertPopup("선택된 의료진의 진료 시간이 아닙니다.");
          return;
        }

        if (compHour > callETime) {
          openAlertPopup("선택된 의료진의 진료 시간이 아닙니다..");
          return;
        }
      }

      setAppHour(compHour);
    }
    setSaveFlag("Y");
  };

  useEffect(() => {
    initLayout(auth);
  }, []);

  return (
    <div
      className="blacklayer-container visit-receipt-layer"
      style={{ zIndex: 99999 }}>
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box reltv priv">
            <div className="blgr-title">병원접수</div>
            <a href={void 0} className="btn-circlexbtn"></a>

            <div className="health-input-contain btpad">
              <div className="input-list">
                <ul>
                  <li>
                    <div className="title">병원명</div>
                    <div>
                      <input type="text" id="hpNm" readOnly />
                      <input type="hidden" id="resrvType" />
                    </div>
                  </li>
                  <li id="doctorList">
                    <div className="title">의료진 선택</div>
                    <div className="select-intext">
                      <div className="select-custom-box">
                        <a className="btn-select inb2">의료진 선택</a>
                        <ul>
                          <li>
                            <a
                              onClick={onSelected}
                              license=""
                              starttime=""
                              endtime="">
                              미지정
                            </a>
                          </li>
                          {doctorList != null && doctorList.length > 0
                            ? doctorList.map((m, i) => (
                                <li key={"DL" + i}>
                                  <a
                                    onClick={onSelected}
                                    license={m.doctor[0].license}
                                    starttime={m.doctor[0].startTime}
                                    endtime={m.doctor[0].endTime}>
                                    {m.doctor[0].DrName}
                                  </a>
                                </li>
                              ))
                            : ""}
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="title">시간선택</div>
                    <div>
                      <div className="picker-container w3 reh">
                        <div className="swiper-container reserv-pick-ampm">
                          <div className="swiper-wrapper">
                            <div className="swiper-slide">
                              <span>오전</span>
                            </div>
                            <div className="swiper-slide">
                              <span>오후</span>
                            </div>
                          </div>
                        </div>

                        <div className="swiper-container reserv-pick-hour">
                          <div className="swiper-wrapper">
                            <div className="swiper-slide">
                              <span>1</span>
                            </div>
                            <div className="swiper-slide">
                              <span>2</span>
                            </div>
                            <div className="swiper-slide">
                              <span>3</span>
                            </div>
                            <div className="swiper-slide">
                              <span>4</span>
                            </div>
                            <div className="swiper-slide">
                              <span>5</span>
                            </div>
                            <div className="swiper-slide">
                              <span>6</span>
                            </div>
                            <div className="swiper-slide">
                              <span>7</span>
                            </div>
                            <div className="swiper-slide">
                              <span>8</span>
                            </div>
                            <div className="swiper-slide">
                              <span>9</span>
                            </div>
                            <div className="swiper-slide">
                              <span>10</span>
                            </div>
                            <div className="swiper-slide">
                              <span>11</span>
                            </div>
                            <div className="swiper-slide">
                              <span>12</span>
                            </div>
                          </div>
                        </div>

                        <div className="swiper-container reserv-pick-minute">
                          <div className="swiper-wrapper">
                            <div className="swiper-slide">
                              <span>00</span>
                            </div>
                            <div className="swiper-slide">
                              <span>01</span>
                            </div>
                            <div className="swiper-slide">
                              <span>02</span>
                            </div>
                            <div className="swiper-slide">
                              <span>03</span>
                            </div>
                            <div className="swiper-slide">
                              <span>04</span>
                            </div>
                            <div className="swiper-slide">
                              <span>05</span>
                            </div>
                            <div className="swiper-slide">
                              <span>06</span>
                            </div>
                            <div className="swiper-slide">
                              <span>07</span>
                            </div>
                            <div className="swiper-slide">
                              <span>08</span>
                            </div>
                            <div className="swiper-slide">
                              <span>09</span>
                            </div>
                            <div className="swiper-slide">
                              <span>10</span>
                            </div>
                            <div className="swiper-slide">
                              <span>11</span>
                            </div>
                            <div className="swiper-slide">
                              <span>12</span>
                            </div>
                            <div className="swiper-slide">
                              <span>13</span>
                            </div>
                            <div className="swiper-slide">
                              <span>14</span>
                            </div>
                            <div className="swiper-slide">
                              <span>15</span>
                            </div>
                            <div className="swiper-slide">
                              <span>16</span>
                            </div>
                            <div className="swiper-slide">
                              <span>17</span>
                            </div>
                            <div className="swiper-slide">
                              <span>18</span>
                            </div>
                            <div className="swiper-slide">
                              <span>19</span>
                            </div>
                            <div className="swiper-slide">
                              <span>20</span>
                            </div>
                            <div className="swiper-slide">
                              <span>21</span>
                            </div>
                            <div className="swiper-slide">
                              <span>22</span>
                            </div>
                            <div className="swiper-slide">
                              <span>23</span>
                            </div>
                            <div className="swiper-slide">
                              <span>24</span>
                            </div>
                            <div className="swiper-slide">
                              <span>25</span>
                            </div>
                            <div className="swiper-slide">
                              <span>26</span>
                            </div>
                            <div className="swiper-slide">
                              <span>27</span>
                            </div>
                            <div className="swiper-slide">
                              <span>28</span>
                            </div>
                            <div className="swiper-slide">
                              <span>29</span>
                            </div>
                            <div className="swiper-slide">
                              <span>30</span>
                            </div>
                            <div className="swiper-slide">
                              <span>31</span>
                            </div>
                            <div className="swiper-slide">
                              <span>32</span>
                            </div>
                            <div className="swiper-slide">
                              <span>33</span>
                            </div>
                            <div className="swiper-slide">
                              <span>34</span>
                            </div>
                            <div className="swiper-slide">
                              <span>35</span>
                            </div>
                            <div className="swiper-slide">
                              <span>36</span>
                            </div>
                            <div className="swiper-slide">
                              <span>37</span>
                            </div>
                            <div className="swiper-slide">
                              <span>38</span>
                            </div>
                            <div className="swiper-slide">
                              <span>39</span>
                            </div>
                            <div className="swiper-slide">
                              <span>40</span>
                            </div>
                            <div className="swiper-slide">
                              <span>41</span>
                            </div>
                            <div className="swiper-slide">
                              <span>42</span>
                            </div>
                            <div className="swiper-slide">
                              <span>43</span>
                            </div>
                            <div className="swiper-slide">
                              <span>44</span>
                            </div>
                            <div className="swiper-slide">
                              <span>45</span>
                            </div>
                            <div className="swiper-slide">
                              <span>46</span>
                            </div>
                            <div className="swiper-slide">
                              <span>47</span>
                            </div>
                            <div className="swiper-slide">
                              <span>48</span>
                            </div>
                            <div className="swiper-slide">
                              <span>49</span>
                            </div>
                            <div className="swiper-slide">
                              <span>50</span>
                            </div>
                            <div className="swiper-slide">
                              <span>51</span>
                            </div>
                            <div className="swiper-slide">
                              <span>52</span>
                            </div>
                            <div className="swiper-slide">
                              <span>53</span>
                            </div>
                            <div className="swiper-slide">
                              <span>54</span>
                            </div>
                            <div className="swiper-slide">
                              <span>55</span>
                            </div>
                            <div className="swiper-slide">
                              <span>56</span>
                            </div>
                            <div className="swiper-slide">
                              <span>57</span>
                            </div>
                            <div className="swiper-slide">
                              <span>58</span>
                            </div>
                            <div className="swiper-slide">
                              <span>59</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <p className="tt">
                      진료예약 접수 후, 병원에서 예약확정 단계가 진행됩니다.
                      <br />
                      예약현황을 확인해주세요.
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="tbns-area">
              <a onClick={() => resrvReceipt("I")} className="btn-round wht">
                즉시접수
              </a>
              <a onClick={() => resrvReceipt("R")} className="btn-round wht">
                접수신청
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// 접수처리API
// export const postApi222 = async (userinfo, cfg, phonecfg, appIdx) => {
//     const {userinfo, cfg, phonecfg} = useContext(AppContext);
//     const url = cfg.url+'222';

//     const formData = new FormData();
//     formData.append('userToken',  userinfo.userToken);
//     formData.append('phoneToken',  phonecfg.phoneToken);
//     formData.append('appID', appIdx);

//     const config = {
//         headers: {
//             'content-type': 'multipart/form-data'
//         }
//     }

//     const response = await post(url, formData, config);
//     const body = await JSON.parse(JSON.stringify(response.data));

//     return body;
// }

export const CancelReceipt = props => {
  const { hpNm, hpKey, appIdx, setResrvList, confirmActionType } = props;

  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  useEffect(() => {}, []);

  const cancelReceipt = () => {
    if (confirmActionType === "DEL") {
      request225(userinfo, cfg, phonecfg, appIdx);
    } else {
      request222(userinfo, cfg, phonecfg, appIdx);
    }
  };

  // 접수처리
  const request222 = (userinfo, cfg, phonecfg, appIdx) => {
    PostApi222(userinfo, cfg, phonecfg, appIdx)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          closeLayerFn($(".reserv-cancle-layer"));

          request271(
            userinfo,
            cfg,
            phonecfg,
            getToday("DAY"),
            getToday("DAY"),
            setResrvList
          );
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  // 이력 삭제
  const request225 = (userinfo, cfg, phonecfg, appIdx) => {
    PostApi225(userinfo, cfg, phonecfg, appIdx)
      .then(res => {
        if (res.resultCode === "E000") {
          closeLayerFn($(".reserv-cancle-layer"));
          request271(
            userinfo,
            cfg,
            phonecfg,
            getToday("DAY"),
            getToday("DAY"),
            setResrvList
          );
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <div className="blacklayer-container reserv-cancle-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div>
          <div className="blgrn-box vertical priv">
            {/* <div className="blgr-title">병원접수 취소</div> */}

            <div className="save-question-box">
              [<span>{hpNm}</span>]<br />
              {confirmActionType === "DEL"
                ? "예약을 삭제 하시겠습니까?"
                : "예약을 취소 하시겠습니까?"}
            </div>

            <div className="tbns-area">
              <a
                className="btn-round gray"
                onClick={() => closeLayerFn($(".reserv-cancle-layer"))}>
                취소
              </a>
              <a onClick={() => cancelReceipt()} className="btn-round wht">
                확인
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

//세팅 변수
let pickslideAmpm;
let pickslideHour;
let pickslideMinute;

//저장변수
let ampmInvalue;
let hourInvalue;
let minuteInvalue;

// export const pickerReStartFn = (nDay, nHour, nMin) => {
export const pickerReStartFn = () => {
  let nDay = 0;
  let nHour = getToday("FULL").substring(8, 10);
  let nMin = getToday("FULL").substring(10, 12);

  if (nHour <= "12") {
    nDay = 0;
  } else {
    nDay = 1;
    nHour = parseInt(getToday("FULL").substring(8, 10)) - 12;
  }

  //오전오후
  pickslideAmpm = new Swiper(".reserv-pick-ampm", {
    // Optional parameters
    direction: "vertical",
    slidesPerView: 3,
    centeredSlides: true,
    initialSlide: nDay,
    on: {
      slideChangeTransitionEnd: function () {
        ampmInvalue = $(".reserv-pick-ampm .swiper-slide-active span").html();
      },
    },
  });

  //시
  pickslideHour = new Swiper(".reserv-pick-hour", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 3,
    centeredSlides: true,
    initialSlide: parseInt(nHour) - 1,
    on: {
      slideChangeTransitionEnd: function () {
        hourInvalue = $(".reserv-pick-hour .swiper-slide-active span").html();
      },
    },
  });

  //분
  pickslideMinute = new Swiper(".reserv-pick-minute", {
    // Optional parameters
    direction: "vertical",
    loop: true,
    slidesPerView: 3,
    centeredSlides: true,
    initialSlide: parseInt(nMin),
    on: {
      slideChangeTransitionEnd: function () {
        minuteInvalue = $(
          ".reserv-pick-minute .swiper-slide-active span"
        ).html();
      },
    },
  });
};
